export const color = {
	primary: '#414041',
	secondary: '#ffffff',
	tertiary: '#2249A1',
	headerLogo: '#414041',
	footerBg: 'transparent',

	blackOne: '#000',
	blackTwo: '#43484D',

	buttonNextBgColor: '#000',
	buttonNextTextColor: '#fff',
	buttonNextMobileBgColor: '#000',
	buttonNextMobileTextColor: '#000',
	buttonNextBorderColor: '#fff',
	buttonNextMobileBorderColor: '#fff',
	buttonNextHoverBgColor: '#fff',
	buttonNextHoverTextColor: '#000',
	buttonNextHoverBorderColor: '#000',

	buttonBackBgColor: '#fff',
	buttonBackTextColor: '#000',
	buttonBackMobileBgColor: '#fff',
	buttonBackMobileTextColor: '#000',
	buttonBackBorderColor: '#000',
	buttonBackMobileBorderColor: '#000',
	buttonBackHoverBgColor: '#000',
	buttonBackHoverTextColor: '#fff',
	buttonBackHoverBorderColor: '#000',

	exchangeSelectBtnTextColor: '#fa6532',
	exchangeSelectBtnBgColor: '#ffffff',
	exchangeSelectBtnBorderColor: '#fa6532',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#fa6532',

	exchangeDontSelectBtnTextColor: '#fa6532',
	exchangeDontSelectBtnBgColor: '#ffffff',
	exchangeDontSelectBtnBorderColor: '#fa6532',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#fa6532',

	exchangeRemoveSelectBtnTextColor: '#fa6532',
	exchangeRemoveSelectBtnBgColor: '#ffffff',
	exchangeRemoveSelectBtnBorderColor: '#fa6532',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#fa6532',

	flowButtonSelectedTextColor: '#ffffff',
	flowButtonSelectedBgColor: '#000000',
	flowButtonSelectedBorderColor: '#000000',

	flowButtonOriginalTextColor: '#000000',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#000000',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
